module.exports = __webpack_public_path__ + "img/new_28.0c7ac892.jpg";